// @flow
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getCompanyStock } from '../../actions/stock'
import { StyledSection, StyledChart, InnerCard } from './style'
import ComponentContainer from '../container-component'
import { Radio } from 'antd'
import { Tooltip, View, Axis, Geom } from 'bizcharts'
import { DataSet } from '@antv/data-set'

const RadioButton = Radio.Button
const RadioGroup = Radio.Group

type Props = {
  symbol: string,
  stock: Object,
  onGetStockHistory: (string, string) => void
}

type State = {
  ds: DataSet,
  dv: View,
  dataReady: boolean,
  timeFilter: string,
  initialData: boolean,
  changeFilter: boolean,
  lastOpen: number
}

class ChartStock extends Component<Props, State> {

  state: State = {
    ds: {},
    dv: {},
    dataReady: false,
    timeFilter: '3M',
    initialData: true,
    changeFilter: false,
    lastOpen: 0
  }

  componentDidMount() {

    const { timeFilter } = this.state
    const { 
      symbol, 
      onGetStockHistory, 
      stock: { stockHistory }
    } = this.props

    // check if stock history is already in redux
    if (stockHistory[symbol]) this.setStockData()
    else onGetStockHistory(symbol, timeFilter)
  }

  componentDidUpdate(prevProps, prevState) {

    const { 
      symbol, 
      onGetStockHistory, 
      stock: { stockHistory }
    } = this.props

    const { 
      timeFilter, 
      initialData, 
      changeFilter, 
      lastOpen 
    } = this.state

    // get new data on symbol change
    if (prevProps.symbol !== symbol) {

      this.setStockData()
      this.setState({ initialData: true })

    } else if (timeFilter !== prevState.timeFilter) {

      // time filter changed
      if (symbol && (timeFilter !== prevState.timeFilter)) {

        // filter is changings & save last open
        this.setState({ 
          changeFilter: true,
          lastOpen: stockHistory[symbol][0].open
        })

        // get new data
        onGetStockHistory(symbol, timeFilter)
      }

      // display loading
      this.setState({ dataReady: false })

    } else if (changeFilter && (stockHistory[symbol][0].open !== lastOpen)) {

      // filter completed changing data
      this.setStockData()
      this.setState({ changeFilter: false })

    } else if (initialData && stockHistory[symbol]) {

      // initial data & set initial open
      this.setStockData()
      this.setState({ initialData: false })
    } 
  }

  setStockData = () => {

    // set stock data
    const { 
      symbol, 
      stock: { stockHistory }
    } = this.props

    this.setState(() => ({
      ds: new DataSet({ 
        state: { 
          open: stockHistory[symbol][0].date, 
          close: stockHistory[symbol][stockHistory[symbol].length - 1].date 
        } 
      })
    }), () => {

      // on update ds set dv
      const { ds } = this.state
      
      this.setState(() => ({ 
        dataReady: true,
        dv: ds.createView().source(stockHistory[symbol]).transform({
          type: 'filter',
          callback: obj => {
            const date = obj.date
            return date <= ds.state.close && date >= ds.state.open
          }
        }).transform({
          type: 'map',
          callback: obj => {
            obj.trend = (obj.open <= obj.close) ? 'rise' : 'fall'
            obj.range = [obj.open, obj.close, obj.high, obj.low]
            return obj
          }
        })
      }))
    })
  }

  onChange = ({ target }) => {

    // set filter
    this.setState({ timeFilter: target.value })
  }

  render() {

    // columns
    const cols: Object = {
      'date': {
        type: 'timeCat',
        nice: false,
        range: [0, 1]
      },
      trend: {
        values: ['rise', 'fall']
      }
    }

    // state and props
    const {
      dv,
      dataReady,
      timeFilter
    } = this.state

    const {
      symbol,
      stock: { stockStatus }
    } = this.props
    
    return (
      <StyledSection>
      { !!stockStatus[symbol] &&
        
        <ComponentContainer 
          title={stockStatus[symbol].error || `Stock: ${symbol}`}
          loading={stockStatus[symbol].isFetching}
          empty={!!stockStatus[symbol].error}
          resetData={this.setStockData}> 

          <RadioGroup defaultValue='3M' value={timeFilter} onChange={this.onChange}>
            <RadioButton value='1M'>1M</RadioButton>
            <RadioButton value='3M'>3M</RadioButton>
            <RadioButton value='1Y'>1Y</RadioButton>
            <RadioButton value='2Y'>2Y</RadioButton>
          </RadioGroup>
          
          <InnerCard loading={!dataReady} bordered={false}>
            <StyledChart
              height={200}
              animate={false}
              padding={[20, 60, 0, 60]}
              data={dv}
              scale={cols}
              forceFit>

              <Tooltip
                showTitle={false}
                itemTpl='
                  <li data-index={index}>
                    <span style="background-color:{color};" class="g2-tooltip-marker">
                  </span>{name}{value}</li>' />

              <View end={{ x: 1, y: 0.5 }} data={dv}>

                <Axis name='date' />
                <Axis name='range' />

                <Geom
                  type='schema'
                  shape='candle'
                  position='date*range'
                  color={['trend', (val: string) => val === 'rise' ? '#2fc25b' : '#f04864']}
                  tooltip={['date*open*close*high*low', (date, open, close, high, low) => {
                    return {
                      name: date,
                      value: `<br><span style="padding-left: 16px">Open：${open}</span><br/>
                        <span style="padding-left: 16px">Close：${close}</span><br/>
                        <span style="padding-left: 16px">High：${high}</span><br/>
                        <span style="padding-left: 16px">Low：${low}</span>`
                    }
                  }]}
                />

              </View>
            </StyledChart>
          </InnerCard>
        </ComponentContainer>
      }
      </StyledSection>
    )
  }
}

const mapStateToProps = (state: Object) => ({
  stock: state.stock
})

const mapDispatchToProps = (dispatch: Function) => ({
  onGetStockHistory(symbol: string, time: string) {
    getCompanyStock(dispatch, symbol, time)
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(ChartStock)



// WEBPACK FOOTER //
// ./src/components/chart-stock/index.js